<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <page-title title="Skip the queue, book a seat!" />
<!--            <v-img-->
<!--              src="https://gemscms.aptsys.com.sg/gems_images/emenumobileCoupon/21/20200807153847.png"-->
<!--              height="180"-->
<!--            >-->
<!--            </v-img>-->
            <div
              class="mt-2"
              :style="aboutStyle"
            >
              <div v-if="restaurantAddress">
                <span>
                  <v-icon
                    class="middle mt-1"
                    size="13"
                    :color="theme.title_color"
                  >fas fa-map-marker-alt</v-icon>
                  {{ restaurantAddress }}
                </span>
              </div>
              <div v-if="openingHours">
                <span>
                  <v-icon
                    class="middle mt-1"
                    size="13"
                    :color="theme.title_color"
                  >fas fa-clock</v-icon>
                  {{ openingHours.hours }}
                </span>
              </div>
              <div v-if="restaurantContact">
                <span>
                  <v-icon
                    class="middle mt-1"
                    size="13"
                    :color="theme.title_color"
                  >fas fa-phone</v-icon>
                  {{ restaurantContact }}
                </span>
              </div>
            </div>
            <div
              v-if="reservationConfig.tnc.length > 0"
              class="mt-3"
              :style="tncStyle"
            >
              <span class="tnc-title">Terms and Conditions</span>
              <ul class="tnc">
                <li
                  v-for="(tnc, index) in reservationConfig.tnc"
                  :key="index"
                >{{ tnc }}</li>
              </ul>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
    >
      <v-btn
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="goToNextPage"
          >
            {{ isMember ? $t('get_started') : $t('signup') }}
          </v-flex>
        </v-layout>
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import BillLine from '~/components/BillLine'

export default {
  name: 'reservation-tnc-view',
  metaInfo () {
    return { title: this.$t('reservations') }
  },
  components: {
    'page-title': PageTitle
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'restaurantContact', 'restaurantAddress', 'openingHours', 'reservationConfig'
    ]),
    ...mapGetters('auth', [
      'authenticated'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    aboutStyle () {
      return {
        fontSize: '13px',
        color: this.theme.title_color
      }
    },
    tncStyle () {
      return {
        color: this.theme.title_color
      }
    }
  },
  methods: {
    goToNextPage () {
      if (this.isMember) {
        this.$router.push({ name: 'reservations' })
      } else if (this.authenticated) {
        this.$router.push({ name: 'register2' })
      } else {
        this.$router.push({ name: 'register' })
      }
    }
  },
  async created () {

  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
  padding: 0 16px;
}
.middle {
  padding: 2px 4px 2px 2px;
}
.tnc-title {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
}
.tnc {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/reservation_tnc.vue